import script from "./ZakatCalculate.vue?vue&type=script&setup=true&lang=js"
export * from "./ZakatCalculate.vue?vue&type=script&setup=true&lang=js"

import "./ZakatCalculate.vue?vue&type=style&index=0&id=2365ce64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2365ce64"]])

export default __exports__